module.exports = __webpack_public_path__ + "img/lr3.c78165eb.png";